import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../../../../../../base/icons/icon/index.js";
import IconWithTooltip from "../../../../../../base/icons/icon-with-tooltip/index.js";
import { genKey } from "../../../../../../../helpers/keys.js";
import * as S from "./styled.js";
const ProductCardIcon = (props)=>{
    const { icon , descriptions =[] , description  } = props;
    return !!description || !!descriptions.length ? /*#__PURE__*/ _jsx(IconWithTooltip, {
        className: `nico-${icon}`,
        tooltipProps: {
            isNegative: true
        },
        children: /*#__PURE__*/ _jsx(S.TooltipContent, {
            children: description ? description : descriptions?.map((description, index)=>/*#__PURE__*/ _jsx("p", {
                    children: description
                }, genKey({
                    description,
                    index
                })))
        })
    }) : /*#__PURE__*/ _jsx(Icon, {
        "data-testid": "ProductCardIcon",
        className: `nico-${icon}`
    });
};
export default ProductCardIcon;

//# sourceMappingURL=index.js.map